import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const InformationSuperscriptGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('#3661E2', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path d="M1 0H0V1H1V0Z" fill={fillColor} />
      <path d="M1 2H0V5H1V2Z" fill={fillColor} />
    </g>
  );
};

export const InformationSuperscriptSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="5"
      width="1"
      viewBox="0 0 1 5"
      {...(props.svg ?? {})}
    >
      <InformationSuperscriptGroup {...props} />
    </svg>
  );
};
